import { render, staticRenderFns } from "./equipeEditar.vue?vue&type=template&id=53cfbcfc&scoped=true&"
import script from "./equipeEditar.vue?vue&type=script&lang=js&"
export * from "./equipeEditar.vue?vue&type=script&lang=js&"
import style0 from "./equipeEditar.vue?vue&type=style&index=0&id=53cfbcfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cfbcfc",
  null
  
)

export default component.exports